/**
 * @author Fernando Ruano
 * @file constants.js
 * @description BloodPressure Constants
 */

// Generic actions
export const GET_ALL_BLOOD_PRESSURES = 'BloodPressure/GET_ALL_BLOOD_PRESSURES';
export const GET_BLOOD_PRESSURE_BY_ID =
  'BloodPressure/GET_BLOOD_PRESSURE_BY_ID';
export const GET_BLOOD_PRESSURE_BY_PATIENT_ID =
  'BloodPressure/GET_BLOOD_PRESSURE_BY_PATIENT_ID';
export const CREATE_BLOOD_PRESSURE = 'BloodPressure/CREATE_BLOOD_PRESSURE';
export const UPDATE_BLOOD_PRESSURE = 'BloodPressure/UPDATE_BLOOD_PRESSURE';
export const DELETE_BLOOD_PRESSURE_BY_ID =
  'BloodPressure/DELETE_BLOOD_PRESSURE_BY_ID';
